var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLivePaused(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 73,
    viewBox: "0 0 49 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.81869 0.75C10.1094 0.75 12.777 3.41764 12.777 6.70833V66.2917C12.777 69.5824 10.1094 72.25 6.81869 72.25C3.52799 72.25 0.860352 69.5824 0.860352 66.2917V6.70833C0.860352 3.41764 3.52799 0.75 6.81869 0.75ZM42.5687 0.75C45.8594 0.75 48.527 3.41764 48.527 6.70833V66.2917C48.527 69.5824 45.8594 72.25 42.5687 72.25C39.278 72.25 36.6104 69.5824 36.6104 66.2917V6.70833C36.6104 3.41764 39.278 0.75 42.5687 0.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivePaused);
export default __webpack_public_path__ + "static/media/live-paused.0e06f98c4d1386e15a9248b1353d597b.svg";
export { ForwardRef as ReactComponent };